import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/projects-section/components/PageLoaderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/projects-section/components/ProjectArticleInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/ParticleBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/ScrollIndicator.tsx");
